/* unplugin-vue-components disabled */import script from "./ClassGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassGroup.vue?vue&type=script&setup=true&lang=js"

import "./ClassGroup.vue?vue&type=style&index=0&id=6f21e5ba&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f21e5ba"]])

export default __exports__